module.exports = __webpack_public_path__ + "assets/836a180200cd07f0fc7b885daac64048.png";